import Vue from 'vue'
import Vuex from 'vuex'

import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'

Vue.use(Vuex)

const actions = {
  async GET_ASSINATURA({ commit, state }, returnData) {
    const request = await ApiPlans.Assinatura.getAssinatura(true)
    commit('ASSINATURA', request.data.value)
    return request
  },
  async SET_ASSINATURA({ commit }, assinatura) {
    await commit('ASSINATURA', assinatura)
  },
}

export default new Vuex.Store({
  state: {
    assinatura: {},
  },
  getters: {
    ASSINATURA: (state: any) => state.assinatura,
    // eslint-disable-next-line
    ASSINATURA_PLANO_CALCULADORA: (state: any) => {
      if (state.assinatura.planos !== undefined && state.assinatura.planos.length === 1 && state.assinatura.planos.some(p => p.chave === 'plano_calculadora')) {
        return true
      }
    },
    // eslint-disable-next-line
    ASSINATURA_DEMONSTRACAO: (state: any) => state.assinatura.tipoAssinatura === 'Demonstracao',
  },
  // eslint-disable-next-line
  actions: actions,
  mutations: {
    ASSINATURA(context: any, assinatura) {
      // eslint-disable-next-line
      context.assinatura = assinatura
    },
  },
})
